export const TICKET_DETAILS = "TICKET_DETAILS";
export const REPLIED_ON_TICKET = "REPLIED_ON_TICKET";
export const STATUS_LIST = "STATUS_LIST";
export const CHANGE_STATUS = "CHANGE_STATUS";